export default __webpack_public_path__ + "77791d20ededf3ceb799d44e170ff53f.png";